import { objectToFormData } from 'object-to-formdata';

export default async function(params) {
  const headers = new Headers()
  const csrfToken = document.getElementsByName('csrf-token').item(0).content
  headers.append('X-CSRF-Token', csrfToken)

  if (params.method === 'GET') {
    const search = new URLSearchParams(params.data).toString()
    const response = await fetch(`${params.url}?${search}`, {
      headers: headers,
      credentials: "include"
    })
    return response
  } else {
    const response = await fetch(params.url, {
      method: params.method,
      headers: headers,
      body: objectToFormData(params.data || {}),
      credentials: "include"
    })
    return response
  }
}
